import { PlatformCode } from 'type/common';
import { IDiscoverDB } from 'type/db';
import round, { floatFixed, roundFloat } from 'utils/round';

export interface IHeader {
	header: string;
	name: string;
	width: number;
	type: 'none' | 'common' | 'number' | 'etc';
	tooltip_text?: string;
}

export const ig_header_arr: IHeader[] = [
	{ header: 'NO.', name: 'number', width: 56, type: 'none' },
	{ header: '', name: 'profile', width: 88, type: 'none' },
	{ header: '아이디', name: 'username', width: 182, type: 'common' },
	{ header: '', name: 'icons', width: 148, type: 'none' },
	{ header: '카테고리', name: 'category', width: 210, type: 'common' },
	{
		header: '오디언스',
		name: 'audience',
		width: 100,
		type: 'common',
		tooltip_text:
			'오디언스는 콘텐츠를 시청하고 있는 사람입니다. 주요 오디언스의 인구 통계 비율을 확인하세요.',
	},
	{
		header: '팔로워',
		name: 'follower_count',
		width: 100,
		type: 'number',
		tooltip_text: '팔로워는 해당 계정을 팔로우하고 있는 계정의 수입니다.',
	},
	{
		header: '유효 팔로워',
		name: 'real_follower_count',
		width: 100,
		type: 'number',
		tooltip_text: '팔로워는 해당 계정을 팔로우하고 있는 계정의 수입니다.',
	},
	{
		header: '평균 도달 수',
		name: 'reach_score',
		width: 100,
		type: 'number',
		tooltip_text:
			'도달 수란 광고를 포함하여 콘텐츠를 1회 이상 본 사람의 수입니다. 평균 도달 수는 최근 12개 게시글 기준으로 계산됩니다.',
	},
	{
		header: '릴스 비율',
		name: 'sub_video_rate',
		width: 100,
		type: 'number',
		tooltip_text: '릴스 비율이란 총 포스팅 중 릴스 게시물의 비율입니다. ',
	},
	{
		header: '팔로워 성장성',
		name: 'follower_growth_list',
		width: 204,
		type: 'etc',
		tooltip_text: '팔로워 성장성이란 최근 6개월간 팔로워 수의 변동을 나타냅니다.',
	},
	// {
	// 	header: '평균 팔로워 수 성장률 (30일)',
	// 	name: 'follower_growth_rate',
	// 	width: 182,
	// 	type: 'common',
	// 	tooltip_text:
	// 		'평균 팔로워 수 성장률이란 30일 전 기준으로 팔로워 수가 증감된 비율입니다.',
	// },
];

export const yt_header_arr: IHeader[] = [
	{ header: 'NO.', name: 'number', width: 56, type: 'none' },
	{ header: '', name: 'profile', width: 88, type: 'none' },
	{ header: '아이디', name: 'username', width: 182, type: 'common' },
	{ header: '', name: 'icons', width: 148, type: 'none' },
	{ header: '카테고리', name: 'category', width: 210, type: 'common' },
	{
		header: '오디언스',
		name: 'audience',
		width: 100,
		type: 'common',
		tooltip_text:
			'오디언스는 콘텐츠를 시청하고 있는 사람입니다. 주요 오디언스의 인구 통계 비율을 확인하세요.',
	},
	{
		header: '구독자',
		name: 'follower_count',
		width: 100,
		type: 'number',
		tooltip_text: '구독자는 해당 채널을 구독하고 있는 계정의 수입니다. ',
	},
	{
		header: 'ER',
		name: 'real_engagement',
		width: 100,
		type: 'number',
		tooltip_text:
			'반응률(ER)이란 구독자 대비 얼마나 많이 좋아요나 댓글 등에 반응 했는지에 대한 비율입니다.',
	},
	{
		header: '평균 조회 수',
		name: 'reach_score',
		width: 100,
		type: 'number',
		tooltip_text:
			'평균 조회 수는 최근 50개 영상 기준으로 조회 수 평균을 계산한 값입니다.',
	},
	{
		header: '쇼츠 비율',
		name: 'sub_video_rate',
		width: 100,
		type: 'number',
		tooltip_text: '쇼츠 비율이란 최근 50개 영상 중 쇼츠 게시물의 비율입니다.',
	},
	{
		header: '구독자 성장성',
		name: 'follower_growth_list',
		width: 204,
		type: 'etc',
		tooltip_text: '구독자 성장성이란 최근 6개월간 구독자 수의 변동을 나타냅니다.',
	},
	// {
	// 	header: '평균 구독자 수 성장률 (30일)',
	// 	name: 'follower_growth_rate',
	// 	width: 182,
	// 	type: 'common',
	// 	tooltip_text:
	// 		'평균 구독자 성장률이란 30일 전 기준으로 구독자 수가 증감된 비율입니다.',
	// },
];

export const nb_header_arr: IHeader[] = [
	{ header: 'NO.', name: 'number', width: 56, type: 'none' },
	{ header: '', name: 'profile', width: 88, type: 'none' },
	{ header: '아이디', name: 'username', width: 182, type: 'common' },
	{ header: '', name: 'icons', width: 148, type: 'none' },
	{ header: '카테고리', name: 'category', width: 210, type: 'common' },
	{
		header: '게시글 수',
		name: 'post_count',
		width: 100,
		type: 'number',
		tooltip_text:
			'게시글 수는 해당 블로그 계정에 업로드 된 포스팅(콘텐츠) 전체 수입니다.',
	},
	{
		header: '누적 방문자',
		name: 'total_visitor',
		width: 100,
		type: 'number',
		tooltip_text:
			'누적 방문자 수는 블로그가 걔설되고 블로그를 1회 이상 방문한 사람의 수입니다.',
	},
	{
		header: '일 방문자',
		name: 'avg_today_visitor',
		width: 100,
		type: 'number',
		tooltip_text: '일 방문자 수는 최근 30일 기준으로 방문자 수 평균을 계산한 값 입니다.',
	},
	{
		header: '평균 조회 수',
		name: 'reach_score',
		width: 100,
		type: 'number',
		tooltip_text:
			'평균 조회 수는 최근 10개 포스팅(콘텐츠) 기준으로 조회 수 평균을 계산한 값입니다.',
	},
	{
		header: '누적 방문자 성장성',
		name: 'follower_growth_list',
		width: 204,
		type: 'etc',
		tooltip_text: '누적 방문자 성장성이란 최근 6개월 간 방문자 수의 변동을 나타냅니다.',
	},
	// {
	// 	header: '평균 누적 방문자 수 성장률 (30일)',
	// 	name: 'follower_growth_rate',
	// 	width: 182,
	// 	type: 'common',
	// 	tooltip_text:
	// 		'평균 누적 방문자 수란 30일 전 기준으로 누적 방문자 수가 증가된 비율입니다.',
	// },
];

export const tt_header_arr: IHeader[] = [
	{ header: 'NO.', name: 'number', width: 56, type: 'none' },
	{ header: '', name: 'profile', width: 88, type: 'none' },
	{ header: '아이디', name: 'username', width: 182, type: 'common' },
	{ header: '', name: 'icons', width: 148, type: 'none' },
	{ header: '카테고리', name: 'category', width: 210, type: 'common' },
	{
		header: '오디언스',
		name: 'audience',
		width: 100,
		type: 'common',
		tooltip_text:
			'오디언스는 콘텐츠를 시청하고 있는 사람입니다. 주요 오디언스의 인구 통계 비율을 확인하세요.',
	},
	{
		header: '팔로워',
		name: 'follower_count',
		width: 100,
		type: 'number',
		tooltip_text: '팔로워는 해당 계정을 팔로우하고 있는 계정의 수입니다.',
	},
	{
		header: 'ER',
		name: 'real_engagement',
		width: 100,
		type: 'number',
		tooltip_text:
			'반응률(ER)이란 팔로워 대비 얼마나 많이 좋아요나 댓글 등에 반응 했는지에 대한 비율입니다.',
	},
	{
		header: '평균 조회 수',
		name: 'reach_score',
		width: 100,
		type: 'number',
		tooltip_text:
			'평균 조회 수는 최근 12개 영상 기준으로 조회 수 평균을 계산한 값입니다.',
	},
	{
		header: '팔로워 성장성 ',
		name: 'follower_growth_list',
		width: 204,
		type: 'etc',
		tooltip_text: '팔로워 성장성이란 최근 6개월 간 팔로워 수의 변동을 나타냅니다.',
	},
	// {
	// 	header: '평균 팔로워 수 성장률 (30일)',
	// 	name: 'follower_growth_rate',
	// 	width: 182,
	// 	type: 'common',
	// 	tooltip_text: '평균 팔로워 수란 30일 전 기준으로 팔로워 수가 증가된 비율입니다.',
	// },
];

export const platform_header_mapper: Record<PlatformCode | 'none', IHeader[]> = {
	ig: ig_header_arr,
	yt: yt_header_arr,
	nb: nb_header_arr,
	tt: tt_header_arr,
	none: [],
};

export const header_value_mapper: Record<
	string,
	(data: IDiscoverDB, hide_info: boolean) => string
> = {
	follower_count(data) {
		if (data.follower_count === null) return '-';
		return round(data.follower_count, 'down') + ' 명';
	},
	real_follower_count(data, hide_info) {
		if (hide_info) return '***명';
		if (data.real_follower_count === null) return '-';
		return round(data.real_follower_count, 'down') + ' 명';
	},
	reach_score(data, hide_info) {
		if (hide_info) return '***명';
		if (data.reach_score === null) return '-';

		const result = round(data.reach_score, 'down');

		if (data.platform === 'ig') return result + '명';
		return result + '회';
	},
	cpr(data, hide_info) {
		if (hide_info) return '***명';
		if (data?.cpr !== 0 && !data?.cpr) return '-';
		return round(data.cpr, 'down') + '원';
	},
	campaign_price(data, hide_info) {
		if (hide_info) return '***명';
		if (data.campaign_price === null) return '-';
		if (data.campaign_price < 0) return '-';
		if (data?.campaign_price === 1000000000) return '별도 협의';
		return round(data.campaign_price, 'down') + '원';
	},
	real_engagement(data, hide_info) {
		if (hide_info) return '**%';
		if (data?.real_engagement !== 0 && !data?.real_engagement) return '-';
		return floatFixed(roundFloat(data?.real_engagement, 'down', 2), 2) + '%';
	},
	cpv(data, hide_info) {
		if (hide_info) return '***원';
		if (data?.cpv !== 0 && !data?.cpv) return '-';
		if (data?.cpv < 0) return '-';
		if (data?.cpv === 1000000000) return '별도 협의';
		return round(data.cpv, 'down') + '원';
	},
	post_count(data, hide_info) {
		if (hide_info) return '***개';
		if (data?.post_count !== 0 && !data?.post_count) return '-';
		return round(data?.post_count, 'down') + '개';
	},
	total_visitor(data) {
		// if (hide_info) return '***명';
		if (data?.total_visitor !== 0 && !data?.total_visitor) return '-';
		return round(data?.total_visitor, 'down') + '명';
	},
	avg_today_visitor(data, hide_info) {
		if (hide_info) return '***명';
		if (data?.avg_today_visitor !== 0 && !data?.avg_today_visitor) return '-';
		return round(data?.avg_today_visitor, 'down') + '명';
	},
};
